import { render, staticRenderFns } from "./SendWhatsappModal.vue?vue&type=template&id=20dcec8c&scoped=true&"
import script from "./SendWhatsappModal.vue?vue&type=script&lang=js&"
export * from "./SendWhatsappModal.vue?vue&type=script&lang=js&"
import style0 from "./SendWhatsappModal.vue?vue&type=style&index=0&id=20dcec8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dcec8c",
  null
  
)

export default component.exports